//小组新增
<template>
  <div class="groupingedit">
    <el-tabs
      v-model="activeName"
      type="card"
      @tab-click="handleClick"
      label-width="80px"
      size="mini"
    >
      <el-tab-pane label="已审" disabled name="first">已审</el-tab-pane>
      <el-tab-pane label="待审" disabled name="second">待审</el-tab-pane>
      <el-tab-pane label="回收站" disabled name="third">回收站</el-tab-pane>
      <el-tab-pane label="添加" disabled name="fourth">添加</el-tab-pane>
      <el-tab-pane label="导出" disabled name="fifth ">导出</el-tab-pane>
      <el-tab-pane label="新增小组" name="sixth">
        <div class="underline">
          <el-form
            ref="form"
            :model="form"
            label-width="100px"
            size="mini"
            :inline="false"
          >
            <div class="underline-first">
              <el-form-item label="类型">
                <el-col :span="6">
                  <el-select v-model="form.type" placeholder="请选择">
                    <el-option label="在线学习" value=""></el-option>
                  </el-select>
                </el-col>
              </el-form-item>
            </div>
            <div class="underline-item">
              <el-form-item label="小组名称">
                <el-col :span="6">
                  <el-input
                    v-model="form.name"
                    oninput="if(value.length > 20) value=value.slice(0, 20)"
                  ></el-input>
                </el-col>
              </el-form-item>
            </div>
            <div class="underline-item">
              <el-form-item label="办学单位">
                <el-col :span="6">
                  <el-input
                    v-model="form.schoolUnit"
                    oninput="if(value.length > 20) value=value.slice(0, 20)"
                  >
                  </el-input>
                </el-col>
              </el-form-item>
            </div>
            <div class="underline-item">
              <el-form-item label="指导老师" v-model="form.teacherNames">
                <div style="display: flex">
                  <div
                    v-for="(item, index) in multipleSelection"
                    :key="index"
                    style="position: relative; margin-right: 20px"
                  >
                    <span>{{ item.uname }}</span>
                    <span class="delete" @click="showFiguredelete(index)"
                      >×</span
                    >
                  </div>
                </div>
                <el-button type="text" @click="chooseTeachers">
                  <p>+选择老师</p>
                </el-button>
              </el-form-item>
            </div>
            <el-dialog
              customClass="customWidth"
              title="指导老师"
              :visible.sync="dialogTableVisible1"
            >
              <el-table
                @selection-change="handleSelectionChange"
                :data="gridData"
                border
                height="250"
                style="width: 100%"
              >
                <el-table-column
                  property="state"
                  type="selection"
                  label="状态"
                ></el-table-column>
                <el-table-column
                  property="uid"
                  type="index"
                  label="序号"
                  width="50"
                ></el-table-column>
                <el-table-column
                  property="uname"
                  label="姓名"
                  sortable
                  width="150"
                ></el-table-column>
                <el-table-column
                  property="mhmName"
                  label="主考院校"
                  min-width="150"
                ></el-table-column>
                <!-- <el-table-column
                  property="partnerInstitutions"
                  label="合作院校"
                  width="150"
                ></el-table-column>
                <el-table-column
                  property="organization"
                  label="机构"
                  width="120"
                ></el-table-column> -->
                <el-table-column
                  property="groupName"
                  width="100px"
                  label="所在分组"
                ></el-table-column>
              </el-table>
              <div class="button-right">
                <el-button
                  type="text"
                  style="width: 50px; height: 25px; line-height: 1px"
                  >{{ multipleSelection.length }}/{{
                    gridData.length
                  }}</el-button
                >
                <el-button
                  type="primary"
                  :plain="true"
                  @click="open"
                  style="
                    width: 50px;
                    height: 25px;
                    line-height: 1px;
                    padding-left: 10px;
                  "
                  >确认</el-button
                >
                <el-button
                  @click="cancel"
                  style="
                    width: 50px;
                    height: 25px;
                    line-height: 1px;
                    padding-left: 10px;
                  "
                  >取消</el-button
                >
              </div>
            </el-dialog>
            <div class="underline-first">
              <el-form-item label="学生" v-model="form.studentNames">
                <div style="display: flex">
                  <div
                    v-for="(item, index) in multipleSelection1"
                    :key="index"
                    style="position: relative; margin-right: 20px"
                  >
                    <span>{{ item.uname }}</span>
                    <span class="delete" @click="showFiguredelete1(index)"
                      >×</span
                    >
                  </div>
                </div>
                <el-button type="text" @click="chooseStuders">
                  <p>+选择学生</p>
                </el-button>
              </el-form-item>
            </div>
            <div class="dialog" style="width: 100%">
              <el-dialog
                customClass="customWidth"
                title="学生"
                :visible.sync="dialogTableVisible"
              >
                <el-table
                  @selection-change="handleSelectionChange1"
                  :data="gridData1"
                  border
                  height="250"
                  style="width: 100%"
                >
                  <el-table-column
                    property="state"
                    type="selection"
                    :selectable="selectInit"
                    label="状态"
                  >
                  </el-table-column>
                  <el-table-column
                    property="uid"
                    type="index"
                    label="序号"
                    width="50"
                  ></el-table-column>
                  <el-table-column
                    property="uname"
                    label="姓名"
                    sortable
                    width="100"
                  ></el-table-column>
                  <el-table-column
                    property="mhmName"
                    label="主考院校"
                    min-width="100"
                  ></el-table-column>
                  <!-- <el-table-column
                    property="partnerInstitutions"
                    label="合作院校"
                    width="80"
                  ></el-table-column>
                  <el-table-column
                    property="organization"
                    label="机构"
                    width="80"
                  ></el-table-column> -->
                  <el-table-column
                    property="major"
                    label="专业"
                    width="80"
                  ></el-table-column>
                  <el-table-column
                    property="examNumber"
                    sortable
                    label="准考证号"
                    width="120"
                  ></el-table-column>
                  <el-table-column
                    property="groupName"
                    label="所在分组"
                  ></el-table-column>
                </el-table>
                <div class="button-right">
                  <el-button
                    type="text"
                    style="width: 50px; height: 25px; line-height: 1px"
                    >{{ multipleSelection1.length }}/{{
                      gridData1.length
                    }}</el-button
                  >
                  <el-button
                    type="primary"
                    :plain="true"
                    @click="open1"
                    style="
                      width: 50px;
                      height: 25px;
                      line-height: 1px;
                      padding-left: 10px;
                    "
                    >确认</el-button
                  >
                  <el-button
                    @click="cancel1"
                    style="
                      width: 50px;
                      height: 25px;
                      line-height: 1px;
                      padding-left: 10px;
                    "
                    >取消</el-button
                  >
                </div>
              </el-dialog>
            </div>

            <el-form-item style="margin-top: 30px">
              <el-button
                type="primary"
                @click="saveOrUpdate"
                style="magin-top: 15px"
              >
                确认
              </el-button>
              <el-button @click="cancel4" style="magin-top: 15px">
                取消
              </el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import * as api from '@/api/group/api'

export default {
  name: 'GroupingEdit',
  components: {},
  data() {
    return {
      userType: '',
      mhmId: '',
      dialogTableVisible: false,
      dialogTableVisible1: false,
      multipleSelection: [], //获取选中的，提供给后台
      multipleSelection1: [],
      index: '',
      showFigure: [],
      isShowQuery: false,
      activeName: 'sixth',
      form: {
        name: '',
        schoolUnit: '',
        type: '在线学习',
        teacherNames: '',
        studentNames: '',
        delivery: false,
        effectiveDate: '2021-03-16 11:59:08.558',
        type: [],
        teacherIds: '141,458',
        courseId: '',
        infoType: 1,
        studentIds: 8,
        createUserId: '',
      },
      gridData: [
        {
          uname: '张老师',
          mhmName: '华南理工大学',
          partnerInstitutions: '**职业学院',
          organization: '**培训中心',
          groupName: '',
          major: '产品设计',
          examNumber: '3213562',
        },
      ],
      gridData1: [
        {
          uname: '张三',
          mhmName: '华南理工大学',
          partnerInstitutions: '**职业学院',
          organization: '**培训中心',
          groupName: '',
          major: '产品设计',
          examNumber: '3213562',
        },
      ],

      pageObj1: {
        courseId: this.$route.query.courseId,
        infoType: 'zy_video', //1.zy_video (点播/直播)2.zy_album（套餐）3...
        type: 1, //1.点播2.直播
        id: 1,
      },
    }
  },
  methods: {
    getUserByUid() {
      api.getUserByUid(this.getUId).then(({ data }) => {
        if (data.code === 100000) {
          this.userType = data.data.type
        }
      })
    },
    // 选择老师
    chooseTeachers() {
      this.dialogTableVisible1 = true
      this.getGroupUserList()
    },

    //选择学生
    chooseStuders() {
      this.dialogTableVisible = true
      this.getStudentByCourseList()
    },

    //复选框操作
    selectInit(row, index) {
      if (row.groupName == '' || row.groupName == null) {
        return true //不可勾选
      } else {
        return false //可勾选
      }
    },
    //提示语
    open() {
      if (!this.multipleSelection.length) {
        this.$message('请选择指导老师')
        return
      }
      this.dialogTableVisible1 = false
    },

    open1() {
      if (!this.multipleSelection1.length) {
        this.$message('请选择学生')
        return
      }
      this.dialogTableVisible = false
    },

    handleClick(tab, event) {
      console.log(tab, event)
    },

    //选中确认
    handleSelectionChange(val) {
      console.log('val', val)
      this.multipleSelection = val
    },
    handleSelectionChange1(val) {
      this.multipleSelection1 = val
    },
    // handleSelectionChange2(val) {
    //   this.multipleSelection2 = val;
    // },
    // handleSelectionChange3(val) {
    //   this.multipleSelection3 = val;
    // },
    //跳转
    onSubmit() {
      console.log('submit!')
    },

    //取消
    cancel4() {
      history.go(-1)
    },
    goPage() {
      // this.getParams();
      this.$router.push({
        path:
          '/GroupingList?infoType=zy_video&courseId=' +
          this.$route.query.courseId,
      })
    },

    cancel() {
      this.dialogTableVisible1 = false
      this.gridData = JSON.parse(JSON.stringify(this.gridData))
    },
    cancel1() {
      this.dialogTableVisible = false
      this.gridData1 = JSON.parse(JSON.stringify(this.gridData1))
    },

    // cancel2() {
    //   this.dialogTableVisible2 = false;
    //   this.gridData = JSON.parse(JSON.stringify(this.gridData));
    // },

    // cancel3() {
    //   this.dialogTableVisible3 = false;
    //   this.gridData1 = JSON.parse(JSON.stringify(this.gridData1));
    // },

    //新增数据
    saveOrUpdate() {
      this.loading = true
      this.form.type = 0
      this.form.createUserId = this.getUId
      this.form.teacherNames = this.multipleSelection
        .map((item) => item.uname)
        .join(',')

      this.form.teacherIds = this.multipleSelection
        .map((item) => item.uid)
        .join(',')

      this.form.studentIds = this.multipleSelection1
        .map((item) => item.uid)
        .join(',')
      this.form.studentNames = this.multipleSelection1
        .map((item) => item.uname)
        .join(',')
      console.log(this.form)
      // ?infoType=1
      // &name=小组A
      // &type=0
      // &courseId=1&
      // schoolUnit=北大
      // &studentIds=8
      // &teacherIds=141,458
      //var d = {infoType:1, name:"小组A", type:0, courseId:1, schoolUnit:"北大", studentIds:8, teacherIds:141458}

      if (
        this.form.type ||
        !this.form.name ||
        !this.form.schoolUnit ||
        !this.form.teacherNames ||
        !this.form.studentNames
      ) {
        console.log('this.form', this.form)
        this.$message('新增失败,请完善信息')
      } else {
        api.saveOrUpdate(this.form).then(({ data }) => {
          console.log(data)
          console.log(JSON.stringify(data.data))
          if (data.code == 100000) {
            this.loading = false
            //成功返回列表
            this.$message({ type: 'success', message: data.msg })
            this.goPage()
          } else {
            this.$message({ type: 'error', message: data.msg })
          }
        })
      }
    },

    //获取老师分组数据
    getGroupUserList() {
      this.loading = true
      console.log('=======4')
      api
        .getGroupUserList({
          courseId: this.$route.query.courseId,
          userType: this.userType,
          mhmId: this.mhmId,
        })
        .then(({ data }) => {
          console.log(data)
          console.log(data.data.list)
          console.log(JSON.stringify(data.data.list[0]))
          this.gridData = data.data.list
          this.loading = false
          // this.goPage();
        })
    },

    //获取机构
    getSchoolByUid() {
      api.getSchoolByUid(this.getUId).then(({ data }) => {
        data = data.data
        console.log(data)
        this.form.schoolUnit = data.title
        this.mhmId = data.id
      })
    },

    //获取学生分组数据
    getStudentByCourseList() {
      this.loading = true
      console.log('=======5555')
      console.log(JSON.stringify(this.pageObj1))
      api.getStudentByCourseList(this.pageObj1).then(({ data }) => {
        console.log(data)
        //console.log(data.data.list);
        //console.log(JSON.stringify(data.data.list[0]));
        this.gridData1 = data.data.list
        this.loading = false
        // this.goPage();
      })
    },

    //老师右上角叉号点击删除
    showFiguredelete(index) {
      console.log('showFiguredelete')
      var that = this
      console.log(that.multipleSelection[index])
      that.multipleSelection.splice(index, 1)
    },
    //学生右上角叉号点击删除
    showFiguredelete1(index) {
      console.log('showFiguredelete')
      var that = this
      console.log(that.multipleSelection1[index])
      that.multipleSelection1.splice(index, 1)
    },
    //老师右上角叉号点击删除
    // showFiguredelete2(index) {
    //   console.log("showFiguredelete");
    //   var that = this;
    //   console.log(that.multipleSelection2[index]);
    //   that.multipleSelection2.splice(index, 1);
    // },
    // //学生右上角叉号点击删除
    // showFiguredelete3(index) {
    //   console.log("showFiguredelete");
    //   var that = this;
    //   console.log(that.multipleSelection3[index]);
    //   that.multipleSelection3.splice(index, 1);
    // },
  },
  created() {
    this.getUserByUid()
    this.getSchoolByUid()
    this.form.courseId = this.$route.query.courseId
    this.form.courseType = this.$route.query.courseType
  },
  computed: {
    getUId() {
      return localStorage.getItem('uid') 
    },
  },
}
</script>
<style lang='scss' scoped>
// @import url(); 引入公共css类
// /deep/.el-form-item{
//   border-bottom: 1px solid gray;
//   padding-bottom: 20px;
// }
.underline {
  box-sizing: border-box;
  padding-top: 10px;
}

.underline-first {
  border-bottom: 1px solid rgb(52, 159, 247);
}

.underline-item {
  border-bottom: 1px solid #b3b4b6;
  padding-bottom: 20px;
  padding-top: 15px;
}

p {
  border: 1px solid black;
  width: 100px;
  height: 25px;
  line-height: 24px;
  font-size: 16px;
  color: black;
}

.button-right {
  float: right;
  margin-right: 10px;
  margin-top: 3px;
}

.delete {
  width: 20px;
  height: 20px;
  position: absolute;
  font-size: 18px;
  color: red;
  cursor: pointer;
  top: -10px;
}

.customWidth {
  width: 85%;
  height: 500px;
}
</style>
